module.exports = __webpack_public_path__ + "static/media/Start Icon.c173546d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Start Icon.png
// module id = 263
// module chunks = 0